const filterReportDinasAgcu = {
    idKelas: null,
    idProfilCbt: null,
    typeReport: "AGCU"
}

export default filterReportDinasAgcu;